// Bloco eyebrow + afirmação grande à esquerda / parágrafos à direita
// (ex.: "COMO NOS RELACIONAMOS COM NOSSOS CLIENTES", frame 585:8619).
export default function TwoColumnStatement({
  heading = '',
  statement = '',
  paragraphs = [],
}) {
  const list = Array.isArray(paragraphs) ? paragraphs : [paragraphs]

  return (
    <div className="w-full px-20">
      {heading && (
        // pt-10 alinha ao ritmo dos demais headings da página (o nó do Figma
        // usa pad-top 8 só neste bloco — inconsistência do design)
        <h2 className="pt-10 pb-6 font-inter-extrabold text-2xl tracking-[-0.02em] text-[#454545]">
          {heading}
        </h2>
      )}

      <div className="flex flex-col gap-10 pb-12 md:flex-row md:justify-between md:gap-20">
        <p className="font-inter-black text-[32px] leading-[1.08] tracking-[-0.02em] text-[#454545] md:max-w-[548px]">
          {statement}
        </p>

        <div className="flex flex-col gap-4 pt-2 md:max-w-[564px]">
          {list.filter(Boolean).map((paragraph, index) => (
            <p
              key={index}
              className="font-inter-regular text-base leading-[1.08] text-[#454545]"
            >
              {paragraph}
            </p>
          ))}
        </div>
      </div>
    </div>
  )
}
